import { createSelector } from '@ngrx/store';
import { ingredientsState } from '../root';

export const getIngredientByPLU = (PLU: number) =>
    createSelector(ingredientsState, (ingredients) => {
        const flattenedIngredients = ingredients?.flatMap((ingredient) => ingredient.data?.Ingredients || []);
        const foundIngredient = flattenedIngredients?.find((ing) => ing.IngredientPLU === PLU);
        const foundSwap = flattenedIngredients?.flatMap((ing) => ing.Swaps || []).find((swap) => swap.NewPLU === PLU);

        return foundIngredient || foundSwap || null;
    });
